import cn from 'classnames'
import { Form, InputNumber } from 'antd'
import { Props } from './types'
import { KeyboardEvent } from 'react'
import './input.default.scss'

export const NumberInput = ({ ...props }: Props) => {
  const onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (!/^(?:\d|Backspace|[.])$/.test(e.key)) {
      e.preventDefault()
    }
  }
  return (
    <Form.Item
      className={cn('custom-input', 'input-default', props.className)}
      colon={false}
      {...props.propsItem}
    >
      <InputNumber
        maxLength={10}
        value={props?.propsInputNumber?.value || ''}
        {...props.propsInputNumber}
        onKeyDown={onKeyDown}
      />
    </Form.Item>
  )
}
